import { Center } from '@mantine/core';
import { DanceLoader } from './DanceLoader';
import type { DanceStyleLike } from '../../../src/constants/danceLoaders';

interface ThemedLoaderProps {
  centered?: boolean;
  py?: string | number;
  // Count in these styles (e.g. an event card's styles). Without it the
  // loader uses the page's DanceStyleLoaderProvider, then picks at random.
  danceStyles?: DanceStyleLike[];
}

export function ThemedLoader({ centered = true, py = 'xl', danceStyles }: ThemedLoaderProps) {
  if (centered) {
    return (
      <Center py={py}>
        <DanceLoader danceStyles={danceStyles} />
      </Center>
    );
  }
  return <DanceLoader danceStyles={danceStyles} />;
}
